// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3eI1S","footer":"ReportModalFilter_footer__2m9mZ"};